var stopData = {
	percentageBasedTrailing: {
		valid: false,
		percent: 0
	},
	trendBasedTrailing: {
		valid: false,
		SMA: ""
	},
	saveProfit: {
		valid: false,
		percent: 0
	},
	ATR: {
		valid: false,
		multiple: 0
	},
	quote: {
		valid: false,
		price: 0		
	},	
	strength: {
		valid: false,
		SMA: "",
		percentage: 0	
	},	
	sleep: {
		valid: false,
		weeks: 3,
		percentage: 0	
	},	
	stock: {
		ticker: "",
		stockname: "",
		buyprice: 0,
		marketprice: 0,
		SMA200: 0,
		SMA50: 0,
		SMA20: 0,
		ATR: 0	
	}
}

const stoplossType = {
	ATR :			{id:1, color: 'RGB(248, 198, 108)'},
	Quote :			{id:2, color: 'RGB(240, 123, 102)'},
	Percent :		{id:3, color: 'RGB(248, 198, 108)'},
	SMA20 :			{id:4, color: 'RGB(248, 198, 108)'},
	SMA50 :			{id:5, color: 'RGB(248, 198, 108)'},
	SaveProfit :	{id:6, color: 'RGB(72, 221, 148)'},   
	Strength :		{id:7, color: 'RGB(72, 221, 148)'},   	
	Sleep :			{id:8, color: 'RGB(72, 221, 148)'}, 	
}

export {stopData};
export {stoplossType};
